import { META, SALONS } from './data';

// Distinctive footer: 5-col grid, hours TABLE per salon, mono-type, certifications strip
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0E0E0E] text-[#F2EBDA] mt-20">
      {/* Newsletter band */}
      <div className="border-b border-[#F2EBDA]/10">
        <div className="max-w-[1440px] mx-auto px-8 lg:px-12 py-12 grid lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
          <div>
            <p className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#A88B4F] mb-3">— Quarterly digest</p>
            <p className="font-serif text-3xl lg:text-4xl leading-[1.1]">A short letter, four times a year. <span className="italic text-[#A88B4F]">Acquisitions, journal entries, salon news.</span></p>
          </div>
          <form className="flex items-end gap-3 border-b border-[#F2EBDA]/30 pb-3" onSubmit={(e) => e.preventDefault()}>
            <input data-testid="watch-newsletter" type="email" placeholder="your.email@domain.com" className="flex-1 bg-transparent text-base font-mono outline-none placeholder:text-[#F2EBDA]/30 py-2" />
            <button type="button" className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#A88B4F] hover:text-[#F2EBDA] transition-colors py-2">Subscribe →</button>
          </form>
        </div>
      </div>

      {/* 5-column grid */}
      <div className="max-w-[1440px] mx-auto px-8 lg:px-12 py-16 grid grid-cols-2 lg:grid-cols-5 gap-10 text-[12px]">
        <div className="lg:col-span-2">
          <p className="font-serif text-2xl mb-2">{META.brand} <span className="text-[#A88B4F] italic">{META.tagline}</span></p>
          <p className="text-[#F2EBDA]/55 leading-[1.7] max-w-xs">Authorized Patek Philippe dealer. Vintage Rolex specialist. Independent makers, on consignment, when we believe in the work.</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2EBDA]/35 mt-6">Established {META.established}</p>
        </div>

        {SALONS.map(s => (
          <div key={s.city}>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A88B4F] mb-3">{s.city}</p>
            <p className="text-[#F2EBDA]/80 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: s.addr }} />
            <p className="font-mono text-[11px] text-[#F2EBDA]/55 mb-3">{s.tel}</p>
            <p className="text-[11px] text-[#F2EBDA]/45 leading-relaxed">{s.hours}</p>
            <a href={s.map} className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#A88B4F] mt-3 inline-block hover:text-[#F2EBDA] transition-colors">↗ Directions</a>
          </div>
        ))}
      </div>

      {/* Certifications strip */}
      <div className="border-t border-[#F2EBDA]/10">
        <div className="max-w-[1440px] mx-auto px-8 lg:px-12 py-6 flex flex-wrap items-center justify-between gap-6">
          <div className="flex items-center gap-8 font-mono text-[10px] tracking-[0.25em] uppercase text-[#F2EBDA]/40">
            <span>Authorized Patek Philippe</span>
            <span className="hidden md:inline">·</span>
            <span className="hidden md:inline">Member, FH Genève</span>
            <span className="hidden md:inline">·</span>
            <span className="hidden md:inline">WOSTEP-trained</span>
          </div>
          <div className="flex items-center gap-6 font-mono text-[10px] tracking-[0.25em] uppercase text-[#F2EBDA]/40">
            <button onClick={() => setPage('journal')} className="hover:text-[#A88B4F]">Journal</button>
            <a href="#" className="hover:text-[#A88B4F]">Privacy</a>
            <a href="#" className="hover:text-[#A88B4F]">Terms</a>
            <span className="text-[#F2EBDA]/30">© 2026</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
